export default __webpack_public_path__ + "static/media/57.b99a757e.svg";